export default __webpack_public_path__ + "static/media/Mobile.e86d9acb.svg";